import { useRef } from 'react';
import { useMotion } from '@/hooks/useEditorialMotion';
import SubpageShell from '@/components/feature/SubpageShell';
import BookingCta from '@/components/feature/BookingCta';
import BookButton from '@/pages/home/components/BookButton';
import { stylists, stylistBios } from '@/mocks/home';

export default function ArtistsPage() {
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  return (
    <SubpageShell title="The Artists" description="Meet the people behind our cuts, colours and styles.">
      <section ref={ref} className="bg-background-50 pb-16 md:pb-28">
        <div className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
          {stylists.map((s, i) => (
            <article key={s.name} data-group className="flex flex-col">
              <div data-m="portrait" className="w-full aspect-[3/4] overflow-hidden bg-background-100">
                <img data-m="scale" src={s.src} alt={`${s.name}, ${s.role} at NOVA Hair Studio`} title={`${s.name} — ${s.role}`} width={900} height={1200} className="w-full h-full object-cover object-top" />
              </div>
              <h2 data-m="caption" data-at="0.12" className="mt-6 text-[24px] font-semibold text-foreground-950">{s.name}</h2>
              <p data-m="caption" data-at="0.12" className="mt-1 text-[14px] text-foreground-950">{s.role}</p>
              <dl data-m="caption" data-at="0.12" className="mt-5 border-t border-background-300 pt-4 text-[14px]">
                <dt className="text-foreground-600">Specialty</dt>
                <dd className="mt-1 text-foreground-950">{s.specialty}</dd>
              </dl>
              <p className="mt-4 text-[15px] leading-relaxed text-foreground-700 flex-1">{stylistBios[i]}</p>
              <div className="mt-6"><BookButton variant="outline" small label={`Book with ${s.first}`} /></div>
            </article>
          ))}
        </div>
        <p className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 mt-12 text-[13px] text-foreground-600">Stylist selection happens in the booking step; no stylist is reserved from this page.</p>
      </section>
      <BookingCta title="Find your stylist. Book your visit." text="Pick the stylist whose specialty fits your hair, then choose a time that suits you." />
    </SubpageShell>
  );
}